import React, { FC, PropsWithChildren } from 'react';

import { cn } from '@column/ui';

const SIZE_CLASS_NAMES = { 16: 'size-4', 20: 'size-5', 32: 'size-8', 40: 'size-10' } as const;

// A faint edge for a round flag. It's an overlay: an inset shadow on the svg itself would sit under the flag's fill.
export const FlagEdge: FC<PropsWithChildren<{ size?: keyof typeof SIZE_CLASS_NAMES }>> = ({ size = 20, children }) => (
  <span
    className={cn(
      'relative shrink-0 rounded-full after:pointer-events-none after:absolute after:inset-0 after:rounded-full after:shadow-[inset_0_0_0_1px_rgb(0_0_0/0.05)] dark:after:shadow-[inset_0_0_0_1px_rgb(255_255_255/0.05)]',
      SIZE_CLASS_NAMES[size]
    )}
  >
    {children}
  </span>
);
